import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';

const AdminMembers = () => {
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Members
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6">Users</Typography>
            <Typography variant="body1">Total: 42</Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6} lg={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6">Orders</Typography>
            <Typography variant="body1">Pending: 5</Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6} lg={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6">Jobs</Typography>
            <Typography variant="body1">This month: 555</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminMembers;
